import React from "react";
import Radium from "radium";
import { CircularProgress } from "material-ui";

import DateButtons from "./date-buttons.jsx";
import MarqueeListEntry from "./marquee-list-entry.jsx";

const MarqueeList = ({
  showLoadingIndicator,
  showsByDay,
  films,
  events,
  onChangeDate,
  selectedDate,
  isYearRound
}) => {
  if (showLoadingIndicator) {
    return (
      <div style={styles.loader}>
        <CircularProgress
          mode="indeterminate"
          size={119}
          thickness={7}
          style={{ margin: 10.5 }}
        />
      </div>
    );
  }

  const selectedShows = showsByDay[selectedDate.format()] || {},
    showKeys = Object.keys(selectedShows).sort((a, b) => {
      const filmOrEventA = films[a] || events[a]
      const filmOrEventB = films[b] || events[b]

      if (filmOrEventA && filmOrEventB) {
        return filmOrEventA.name.localeCompare(
          filmOrEventB.name
        );
      }

      return 0;
    });

  return (
    <div>
      <DateButtons
        selectedDate={selectedDate}
        dates={Object.keys(showsByDay)}
        onDateSelected={onChangeDate}
        isYearRound={isYearRound}
      />
      {showKeys.length ? (
        <div style={styles.container}>
          {showKeys.map(k => {
            return (
              <MarqueeListEntry
                key={k}
                id={k}
                showings={selectedShows[k]}
                films={films}
                events={events}
                isMultipleEntries={showKeys.length > 1}
              />
            );
          })}
        </div>
      ) : (
        <div style={styles.nothingScheduled}>
          Nothing scheduled for{" "}
          {selectedDate.format("dddd, MMMM Do").replace(/ /g, " " /* nbsp */)}.
        </div>
      )}
    </div>
  );
};

const styles = {
  loader: {
    padding: 10,
    textAlign: "center"
  },
  container: {
    marginTop: "2em",
    display: "flex",
    flexWrap: "wrap"
  },
  nothingScheduled: {
    fontSize: "14pt",
    textAlign: "center",
    padding: "10px 10%",
    color: "rgba(0,0,0,0.7)",
    fontStyle: "italic",
    minHeight: "30vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }
};

export default Radium(MarqueeList);



// WEBPACK FOOTER //
// ./src/app/components/partials/marquee/marquee-list.jsx